import { call, put, takeLatest } from 'redux-saga/effects';
import HeroShortenerApi from 'api-services/HeroShortenerApi';
import { isSuccessResponse } from 'api-services/types/guards';
import { expandShortlinkDone, expandShortlinkError } from './actionCreators';
import { EXPAND_SHORTLINK } from './actionTypes';
export function* expandShortlink(constAccessParams, action) {
    const result = yield call(HeroShortenerApi.expandShortlink, constAccessParams, action.data);
    if (isSuccessResponse(result)) {
        yield put(expandShortlinkDone(result.data.url));
    }
    else {
        yield put(expandShortlinkError('not-found'));
    }
}
export function* watchExpandShortlinkCalls(constAccessParams) {
    yield takeLatest(EXPAND_SHORTLINK, expandShortlink, constAccessParams);
}
//# sourceMappingURL=saga.js.map